export default __webpack_public_path__ + "static/C01-a05eb12e64a8f7a88b3df7fefdfe2627.jpg";